export default "__VITE_ASSET__Bk_OnMQO__"